import { z } from 'zod';

export enum SapSystem {
  NICE = 'NICE',
  BEST = 'BEST',
}
export const sapSystemSchema = z.enum(SapSystem);
